import { GenericService } from './generic.service';
import { DashboardPatientsStatsResponse } from '@/models';
import apiClient from '@/services/api/client/apiClient';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

export class OrganisationDashboardService extends GenericService<DashboardPatientsStatsResponse> {
  constructor(organisationId: string) {
    super(`v1/organisations/${organisationId}/dashboard`);
  }

  async getPatientCount(
    config: AxiosRequestConfig = {}
  ): Promise<AxiosResponse<DashboardPatientsStatsResponse>> {
    return await apiClient.get(`${this.endpoint}/patient-count`, config);
  }
}
